export default "__VITE_ASSET__Cp7790Zj__"